/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type BatchEvidencesJobRunUpdateInput = {
  id: string;
  status: JobRunStatus;
  tenantId: string;
};

export type JobRunStatus =
  | 'canceled'
  | 'failed'
  | 'in_progress'
  | 'init'
  | 'succeeded';

export type UpdateBatchEvidencesJobRunMutationVariables = Exact<{
  input: Types.BatchEvidencesJobRunUpdateInput;
}>;


export type UpdateBatchEvidencesJobRunMutation = { cnutUpdateBatchEvidencesJobRun: { __typename: 'BatchEvidencesJobRunUpdateOutput', id: string } };


export const UpdateBatchEvidencesJobRunDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBatchEvidencesJobRun"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BatchEvidencesJobRunUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutUpdateBatchEvidencesJobRun"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateBatchEvidencesJobRunMutation, UpdateBatchEvidencesJobRunMutationVariables>;